import { useMemo } from "react";
import {
  ServiceIcons,
  Tooltip,
  TooltipFocusableTrigger,
} from "@zapier/design-system";
import { App, Zap } from "@zapier/client";
import { getServicesFromApis } from "@zapier/utils";
import styles from "./ServiceIconsWithTooltip.module.css";
import {
  getServiceNames,
  getZapServicesFromZDL,
} from "../../../../utils/getZapServicesFromZDL";

interface Props {
  zap?: Zap;
  apps?: Record<string, App>;
  appIds?: string[];
}

export default function ServiceIconsWithTooltip({ zap, apps, appIds }: Props) {
  const services = useMemo(() => {
    if (zap?.currentVersion || zap?.draft) {
      return getZapServicesFromZDL(zap);
    }
    if (zap?.apps) {
      return getServicesFromApis(zap.apps);
    }

    if (appIds) {
      return getServicesFromApis(appIds);
    }

    return [];
  }, [zap, apps, appIds]);

  const serviceNames = getServiceNames(services, apps);

  // Transform service names to replace "Interfaces" with "Forms" (rebrand is now permanent)
  const updatedServiceNames = serviceNames.replaceAll("Interfaces", "Forms");

  if (services.length === 0) {
    return null;
  }

  return (
    <div className={styles.root}>
      {updatedServiceNames.length > 0 ? (
        <Tooltip
          content={updatedServiceNames}
          placement="bottom"
          allowMultiline={true}
        >
          <TooltipFocusableTrigger>
            <ServiceIcons
              hasBorder
              maxServices={3}
              size="small"
              services={services}
            />
          </TooltipFocusableTrigger>
        </Tooltip>
      ) : (
        <ServiceIcons
          hasBorder
          maxServices={3}
          size="small"
          services={services}
        />
      )}
    </div>
  );
}
